import { ApplicationState } from '../../store/rootReducer';
import { NormalizedListById } from '../../core';
import { AccommodationOfferFloorModel } from '../../api/interfaces';

export const getAccommodationOfferFloors = (state: ApplicationState): NormalizedListById<AccommodationOfferFloorModel> => {
    return Object.assign({}, state.accommodationOfferCalculations.floors.byId, state.accommodationOfferCalculations.floors.byId);
};